/**
 * Template Tag JS
 *
 * JS for functions in template-tags.php.
 */

import './mobile-menu';
import './modal';
import './navigation-primary';
import './sticky-header';
import './breadcrumbs';
import './scrollto';
import './feature-banner';
import './off-canvas';
import './table';
import './video';
import './gallery';
import './accordion';
import './comparison';
